import {
  NetworkError,
  deepCamelCase,
  Select,
  searchQueryString,
  intoSnakeCase,
} from '../fetchers/_helpers';
import { LanguageFields, Language } from '../models/components/schemas/language/Language';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetLanguagesFields = readonly LanguageFields[];

/** Options for GET /languages */
export type GetLanguagesOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  /** Available fields on the response type, application/vnd.vimeo.language+json */
  select: Paths;

  /** Possible query parameters for /languages */
  query?: {
    /**
     * The attribute by which to filter the results.
     *
     * Option descriptions:
     *  * `audiotracks` - Return languages that can be used for audio tracks.
     *  * `texttracks` - Return languages that can be used for text tracks.
     *
     */
    filter?: `audiotracks` | `texttracks`;

    /**
     * The page number of the results to show.
     */
    page?: number;

    /**
     * The number of items to show on each page of results, up to a maximum of 100.
     */
    perPage?: number;
  };
};

/** Result type for GET /languages */
export type GetLanguagesResult<Paths extends readonly string[]> = {
  /** The total number of results for GET /languages */
  total: number;
  /** The current page */
  page: number;
  /** The number of results per page specified in the request */
  perPage: number;
  /** Available API endpoints for traversing the paginated data */
  paging: {
    /** The next page, if available */
    next: string | null;
    /** The previous page, if available */
    previous: string | null;
    /** The first page */
    first: string;
    /** The last page */
    last: string;
  };
  /** An array containing the current results */
  data: Select<Language, Paths>[];
};

/**
 * Get all languages
 * This method returns all available video languages.
 */
export async function getLanguages<Paths extends GetLanguagesFields>({
  baseUrl,
  select,
  query,
  ...options
}: GetLanguagesOptions<Paths>): Promise<GetLanguagesResult<Paths>> {
  let res = await fetch(
    `${baseUrl}/languages?${searchQueryString(query)}&fields=${select
      .map(intoSnakeCase)
      .join(',')}`,
    {
      ...options,
      method: 'GET',
    },
  );

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as GetLanguagesResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}
